import { useQuery } from '@tanstack/react-query'
import { getIngredients } from './pantry.service'

export function usePantry() {
  return useQuery({
    queryKey: ['pantry', 'ingredients'],
    queryFn: getIngredients,
    staleTime: 30 * 1000,
  })
}
